import axios from '@/utils/request'

export default {
  newFunctionStationLetterList: (params) => axios({ url: '/api/message/stationLetterList', method: 'GET', params }), // 后台-查询站内信列表
  newFunctionStationLetter: (params) => axios({ url: '/api/message/stationLetter', method: 'GET', params }), // 后台-查询站详情
  newFunctionDeleteStationLetter: (data) => axios({ url: '/api/message/stationLetter', method: 'delete', data }), // 后台-删除站内信
  newFunctionEdit: (data) => axios({ url: '/api/message/editStationLetter', method: 'post', data }), // 后台-新增/编辑站内信内容

  messageCancelSending: params => axios({ url: '/api/message/cancelSending', method: 'put', params }), // 后台-撤销站内信
  
  productTakeDownList: data => axios({ url: '/api/message/productTakeDownList', method: 'post', data }), // 后台-查询产品下架通知列表
  
  editProductTakeDown: data => axios({ url: '/api/message/editProductTakeDown', method: 'post', data }), // 后台-新增产品下架通知

  productCheckSpuOrSku: data => axios({ url: '/api/product/checkSpuOrSku', method: 'post', data }), // 校验spu是否有效
}
